export const rsPreliminaryItems = [
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "1.0",
    Description: "METHOD RELATED ITEMS",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "Principal Contractor - Fixed Costs",
    Qty: "1",
    Unit: "item",
    Rate: "18045.00",
    Amount: "£18,045.00",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "Principal Contractor - Weekly Costs",
    Qty: "8",
    Unit: "wks",
    Rate: "2395.00",
    Amount: "£19,160.00",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "S106 applications",
    Qty: "",
    Unit: "item",
    Rate: "1000.00",
    Amount: "S278 BoQ",
  },
  {
    Item: "",
    Description: "S50 applications",
    Qty: "",
    Unit: "item",
    Rate: "1100.00",
    Amount: "S278 BoQ",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "CBR tests",
    Qty: "1",
    Unit: "item",
    Rate: "4651.75",
    Amount: "£4,651.75",
  },
  {
    Item: "",
    Description: "Binder and grading analysis",
    Qty: "1",
    Unit: "item",
    Rate: "3995.00",
    Amount: "£3,995.00",
  },
  {
    Item: "",
    Description: "NDT's",
    Qty: "1",
    Unit: "item",
    Rate: "5000.00",
    Amount: "£5,000.00",
  },
  {
    Item: "",
    Description: "Core testing",
    Qty: "1",
    Unit: "item",
    Rate: "6875.00",
    Amount: "£6,875.00",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "Jetting & CCTV of installed sewers; once",
    Qty: "1",
    Unit: "item",
    Rate: "14970.00",
    Amount: "£14,970.00",
  },
  {
    Item: "",
    Description: "Jetting & CCTV of installed sewers; second visit",
    Qty: "1",
    Unit: "item",
    Rate: "14970.00",
    Amount: "£14,970.00",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "Cleaning of manholes prior to surfacing",
    Qty: "1",
    Unit: "item",
    Rate: "7905",
    Amount: "£7,905.00",
  },
  {
    Item: "",
    Description: "Cleaning of gullies prior to surfacing",
    Qty: "1",
    Unit: "item",
    Rate: "9130",
    Amount: "£9,130.00",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "Working around existing water main (Including capping) at crossing point only as shown on drawing M018/ENG/PSD/01 (123m2)",
    Qty: "1",
    Unit: "item",
    Rate: "15588.39",
    Amount: "£15,588.39",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "2.0",
    Description: "TREE PROTECTION FENCING",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "2.1",
    Description: "Tree Protection Fencing As BS 5837:2012 Figure 3a",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "Supply and erection of heras fencing on rubber feet.  Fencing to be supported every panel by a scaffold stabilizer strut at 45' with ground pins.",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "Supply of heras, rubber feet, clips and stabiliser strut",
    Qty: "199",
    Unit: "m",
    Rate: "21.44",
    Amount: "Omitted",
  },
  {
    Item: "",
    Description: "Erect heras fencing on feet",
    Qty: "199",
    Unit: "m",
    Rate: "7.43",
    Amount: "Omitted",
  },
  {
    Item: "",
    Description: "Dismantle heras fencing upon completion",
    Qty: "199",
    Unit: "m",
    Rate: "7.43",
    Amount: "Omitted",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "2.2",
    Description: "High Intensity Tree Protection Barrier",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "Supply and erect a scaffold frame driven 600mm into the ground, to which 3.5m heras fence panels are clipped and tied.",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "Supply of heras, scaffold poles, couplers & ties",
    Qty: "1204",
    Unit: "m",
    Rate: "39.93",
    Amount: "Omitted",
  },
  {
    Item: "",
    Description: "Erect heras fencing on poles",
    Qty: "1204",
    Unit: "m",
    Rate: "37.75",
    Amount: "Omitted",
  },
  {
    Item: "",
    Description: "Dismantle heras fencing upon completion",
    Qty: "1204",
    Unit: "m",
    Rate: "28.95",
    Amount: "Omitted",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "3.0",
    Description: "BOUNDARY PROTECTION FENCING - AS MORRIS HOMES QUANTS",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "Supply and erect heras fencing on rubber feet.",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "Supply of heras, rubber feet & clips",
    Qty: "493",
    Unit: "m",
    Rate: "14.38",
    Amount: "Omitted",
  },
  {
    Item: "",
    Description: "Erect heras fencing on feet",
    Qty: "493",
    Unit: "m",
    Rate: "6.75",
    Amount: "Omitted",
  },
  {
    Item: "",
    Description: "Dismantle heras fencing upon completion",
    Qty: "493",
    Unit: "m",
    Rate: "6.75",
    Amount: "Omitted",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "Supply and erection of heras fencing on rubber feet.  Fencing to be supported every panel by a scaffold stabilizer strut at 45' with ground pins.",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "Supply of heras, scaffold poles, couplers & ties",
    Qty: "2073",
    Unit: "m",
    Rate: "19.30",
    Amount: "Omitted",
  },
  {
    Item: "",
    Description: "Erect heras fencing on poles",
    Qty: "2073",
    Unit: "m",
    Rate: "7.43",
    Amount: "Omitted",
  },
  {
    Item: "",
    Description: "Dismantle heras fencing upon completion",
    Qty: "2073",
    Unit: "m",
    Rate: "7.43",
    Amount: "Omitted",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "Carried forward to summary",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "£120,290.14",
  },
];
